<template>
  <div>
    <div style="background: #f8f8f9;width: 100%;padding-left: 20px;padding-top: 5px;padding-bottom: 5px;">
      配电室：<el-select v-model="roomId" placeholder="请选择" style="width: 15%;">
        <el-option v-for="item in roomList" :key="item.id" :label="item.roomName" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div style="padding-left: 18px;padding-right: 18px;height: 100%;">
      <el-row v-for="(item, index) in datas" :key="index" :gutter="0" class="panel-group"
        style="height: 280px;padding-top: 20px;">
        <el-col class="card-panel-col" style="width: 350px;">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-message">
              <div>
                <svg-icon icon-class="bianyaqi2" class-name="card-panel-icon" />
              </div>
              <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                {{item.info.address}}
              </div>

            </div>

            <div class="card-panel-description">
              <div class="card-panel-text-info">
                电室: {{item.info.room}}
              </div>
              <div class="card-panel-text-info">
                编号: {{item.info.localNumber}}
              </div>
              <div class="card-panel-text-info">
                描述: {{item.info.desc}}
              </div>
            </div>

          </div>
        </el-col>
        <el-col :span="9" class="card-panel-col" style="height: 100%;">
          <div style="width: 100%;height: 100%;">
            <v-chart ref="chart1" manual-update></v-chart>
          </div>
        </el-col>
        <el-col :span="9" class="card-panel-col" style="height: 100%;">
          <div style="width: 100%;height: 100%;">
            <v-chart ref="chart2" manual-update></v-chart>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
  // import layout1 from "../../layout/layout1";
  import ECharts from "vue-echarts";
  export default {
    name: "yxzl",
    data () {
      return {
        projectId: 0,
        datas: [],
        elList: [],
        roomList: [],
        roomId: 0
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      }
    },
    components: {
      // layout1, 
      "v-chart": ECharts,
    },
    created () {
      this.projectId = this.$getCookie("projectId");
      this.searchEquipmentRoomList()

    },
    mounted () {

    },
    computed: {

    },
    watch: {
      roomId (n) {
        this.searchPeak(n)
      }
    },
    methods: {
      searchPeak (roomId) {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str = strs[0] + "-" + strs[1]
        this.$http
          .post("bma-distribution-service/monthReport/searchDianliu", {
            date: str,
            projectId: this.projectId,
            roomId,
            dateType: this.dateType
          })
          .then((res) => {
            this.datas = res.data.datas


            this.$nextTick(() => {

              let options = {
                tooltip: {
                  trigger: "axis",
                  formatter: function (params) {
                    let params1 = params[0];
                    let params2 = params[1];
                    return (
                      params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                        params1.axisValue + "：" + params1.value :

                        params1.marker + params1.seriesName + '<br/>' +
                        params1.axisValue + "：" + params1.value +
                        '<br/>' +
                        params2.marker + params2.seriesName + '<br/>' +
                        params2.axisValue + "：" + params2.value



                    );
                  },
                  axisPointer: {
                    animation: false
                  }

                },
                title: { text: "电流不平衡度" },
                color: ['#5470C6', '#00CE7C60'],
                legend: {},
                grid: {
                  top: 70,
                  bottom: 50
                },
                xAxis: [
                  {
                    splitArea: {
                      show: true
                    },
                    type: 'category',
                    axisTick: {
                      alignWithLabel: true
                    },
                    axisLine: {
                      onZero: false,
                      lineStyle: {
                        color: '#5470C6'
                      }
                    },
                    axisPointer: {
                      label: {
                        formatter: function (params) {
                          return (
                            params.value +
                            (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                          );
                        }
                      }
                    },
                    // prettier-ignore
                    data: []
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: [
                  {
                    name: '最高',
                    type: 'line',
                    smooth: true,
                    emphasis: {
                      focus: 'series'
                    },
                    data: [
                      2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
                    ]
                  },
                  {
                    name: '最低',
                    type: 'line',
                    smooth: true,
                    emphasis: {
                      focus: 'series'
                    },
                    data: [
                      3.9, 5.9, 11.1, 18.7, 48.3, 69.2, 231.6, 46.6, 55.4, 18.4, 10.3, 0.7
                    ]
                  }
                ]
              }


              let shebeiIndex = 0
              this.datas.forEach((data) => {
                options.xAxis[0].data = [];
                options.series[0].data = [];
                options.series[1].data = [];

                data.dianliu.forEach((item) => {

                  options.xAxis[0].data.push(item.day)
                  options.series[0].data.push(item.max)
                  options.series[1].data.push(item.min)
                })
                this.$refs.chart1[shebeiIndex].setOption(options, true);
                shebeiIndex++
              })
              if (this.dateType == "1") {
                options.title = { text: "电流不平衡度平均值(小时)" };
              } else {
                options.title = { text: "电流不平衡度平均值(天)" };
              }

              options.series[0].name = "平均值";
              options.series[1] = {}
              shebeiIndex = 0
              this.datas.forEach((data) => {
                options.xAxis[0].data = [];
                options.series[0].data = [];
                options.series[1].data = [];

                data.dianliuav.forEach((item) => {

                  options.xAxis[0].data.push(item.hour)
                  options.series[0].data.push(item.av)
                })
                this.$refs.chart2[shebeiIndex].setOption(options, true);
                shebeiIndex++
              })
            })
          });
      },
      searchEquipmentRoomList () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/equipmentRoom/searchEquipmentRoomListForOverview", {
            projectId: projectId,
          }
          )
          .then((res) => {
            if (res.data) {
              this.searchPeak(0);
              this.roomList = res.data;
              let totle = [{ roomName: "全部", id: 0 }]
              this.roomList = totle.concat(this.roomList)

            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;
    background: #fff;

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .card-panel-col {
      /* margin-bottom: 32px; */
    }

    .card-panel {
      height: 208px;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      border-color: rgba(0, 0, 0, .05);



      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 54px 0 0 14px;
        width: 100px;
        text-align: center;
        /* padding: 16px; */
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        /* float: left; */
        font-size: 48px;
      }

      .card-panel-description {
        float: left;
        font-weight: bold;
        margin-top: 56px;
        margin-left: 10px;
        text-align: left;
        width: 200px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-text-info {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
</style>